<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div class="fs-14 color-33 m-t-10">
      上传图片
    </div>
    <div class="fs-12 color-99 m-v-10 m-t-10" style="margin-right: 0px">
      建议图片尺寸为1242*2688，图片格式为png或jpg，图片大小不超过2mb。
    </div>
    <div
      style="background-color: #F2F2F2;" class="w-full  p-10 relative">
      <hot-zone
        style="position: absolute;left:10px;top: 10px;"
        :style="{position:getPosition()}"
        :image="iteminfo.config.datalist[0].picurl"
        :zonesInit="iteminfo.config.datalist[0].zones"
        @add="handleAdd"
        @change="handleChange"
        @remove="handleRemove"
      />
      <RatioDiv :radio-value="46"
                v-if="iteminfo.config.datalist[0].picurl===''"
      >
        <div style="position: absolute"
             @click="choicePic(iteminfo.config.datalist[0])"
             class="w-full h-full bg-white flex-column">
          <Icon color="#cccccc" size="20" type="ios-add"/>
          <span style="font-size: 10px">上传图片</span>
        </div>
      </RatioDiv>

      <!--      删除按钮-->
      <img src="../../../assets/common/ic_yichu.png"
           v-if="showImg"
           @click="delImg"
           style="position:absolute;right: 0;top: 0;"/>
    </div>

    <ul class="m-t-10">
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2;"
          v-for="(item,index) in iteminfo.config.datalist[0].zones">
        <div class="p-t-10 p-l-10">热区{{ index + 1 }}</div>

        <div class="flex p-10 a-center">
          <div class="flex flex-1" style="flex-direction: row">
            <Input :border="false" class="b-r" placeholder="导航名称" style="width: 100px"
                   v-model="item.jumpObj.linkName"></Input>
            <div class="flex-column" style="height: 100%">
              <tooltip style="width: 100%"
                       :disabled="!item.url"
                       max-width="250">

                <Input
                  clearable readonly
                  v-model:value="item.url">
                  <span slot="append" class="icon-link" style="cursor:pointer"
                        @click.stop="showMaterialModal(item)"></span>
                </Input>
                <div slot="content" style="white-space: normal;">
                  {{ item.url }}
                </div>
              </tooltip>
            </div>
          </div>

          <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
             style="cursor: pointer;color: #666666;margin-left: 10px;"/>

        </div>

      </li>

    </ul>

    <pic-choice-widget
      ref="picChoiceWidget"
      :on-ok="picChoiceOk"
    />

    <materail-choice-weidget
      title="选择链接"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>


  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import RatioDiv from '@/components/common/RatioDiv'
import HotZone from '@/components/common/zone/Hotzone'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'
import MaterailChoiceWeidget from '@/components/common/chiose/MaterialChoiceWidget'

export default {
  name: 'HotZoneSettingWidget',
  components: {
    MaterailChoiceWeidget,
    PicChoiceWidget,
    HotZone,
    RatioDiv,
    BaseSettingWidget,
    UpLoadImage,
  },
  props: {
    iteminfo: Object
  },
  data () {
    return {
      showImg: false,
      showPicChoiceModal: false,
      clickedItem2ShowModal: 0,
      clickItem2ShowMaterialModal: {},
      dataList: [],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // 图片下载完成再显示
      document.getElementById('hotzone-img').onload = () => {
        this.showImg = true
      }
    },
    onDelClick (index) {
      // this.iteminfo.dataList.splice(index, 1)
      this.handleRemove(index)
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    delImg () {
      if (this.iteminfo.config.datalist[0]) {
        this.iteminfo.config.datalist[0].zones = []
      }
      this.iteminfo.dataList = []
      this.iteminfo.coverImgUrl = ''
      this.iteminfo.config.datalist[0].picurl = ''
      this.showImg = false
    },
    handleAdd (zone) {
      zone.url = ''
      console.log(zone)
      // this.iteminfo.config.datalist[0].zones.push(zone)
      // heightPer:0.5333
      // leftPer:0.4222
      // topPer:0.4667
      // url:""
      // widthPer:0.2139

      let zones = this.iteminfo.config.datalist[0].zones
      zones.push({
        'id': 0,
        'topPer': zone.topPer,
        'leftPer': zone.leftPer,
        'widthPer': zone.widthPer,
        'heightPer': zone.heightPer,
        'url': zone.url,
        'name':'',
        'jumpObj': {
          'linkUrl': zone.url,
          'linkName': '',
          'shareTitle': '',
          'shareCover': '',
          'showVideoTitle': 0,
          'showTime': 0,
          'displayType': 1,
          'subDisplayType': 1,
          'ratio': 2,
          'hSpacing': 0,
          'vSpacing': 0,
          'pSee': 1,
          'pPublish': 1,
          'pDevices': 1,
          'pUsers': []
        },
        'title': '热区' + zones.length
      },)

    },
    handleRemove (index) {
      this.iteminfo.config.datalist[0].zones.splice(index, 1)
    },
    handleChange () {

    },
    getPosition () {
      if (this.showImg) {
        return 'unset'
      } else {
        return 'absolute'
      }
    },

    choicePic (item) {
      this.clickItem2ShowPicModal = item
      this.$refs.picChoiceWidget.show()
    },

    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.clickItem2ShowPicModal.picurl = pic.url
        //图片选择,选择图片时,需要上传这个链接;非选择图片,需要为空
        this.clickItem2ShowPicModal.contentLink = pic.linkurl
        this.clickItem2ShowPicModal.title = pic.title
        this.clickItem2ShowPicModal.width = pic.width
        this.clickItem2ShowPicModal.height = pic.height
      }
    },
    showMaterialModal (item, index) {
      this.clickItem2ShowMaterialModal = item
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        let item = this.clickItem2ShowMaterialModal
        item.url = data[0].url
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.item {
  width: 140px;
  height: 170px;
  flex-direction: row;
  margin-bottom: 10px;
}

.item-selected {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid #0EA4FB;
}

.item-normal {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid white;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.lin2 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  line-height: 20px;
  //height: 40px;
  //margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}


.triangle {
  width: 0;
  height: 0;
  border-color: transparent #0F8CFB;
  border-width: 0 25px 25px 0;
  border-style: solid;
}
</style>
